module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II4.9eb7f827.png";